// removed by extract-text-webpack-plugin
module.exports = {"prompt":"_1gR_a","people":"VoH_f","col-info":"_1hf7x","messages":"_3Hc1d","col-share":"_1VbtW","col-btn-share":"_254wB","btn-share":"_1R9cq","link-share":"_9__xz","grey-cross":"_1Txiw","prompt-text":"_25QsR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/ShareWithFriends/ShareWithFriends.scss
// module id = ./src/components/Prompt/ShareWithFriends/ShareWithFriends.scss
// module chunks = 4